import { Injectable } from '@angular/core'

@Injectable()

export class NotificacionesService {


  tabla = 'rest_notificaciones';
  data = [];

  constructor(){

    this.data = JSON.parse(localStorage.getItem(this.tabla)) || [];

  }



  get(){

    return this.data;

  }



  set(data){

    this.data = data;
    localStorage.setItem(this.tabla, JSON.stringify(data));

    return this.data;

  }


  getNotRead(){

    let aux = 0;

    for(let not of this.data){

      if(not.vista == 0){
        aux++;
      }
    }
    return aux;
  }


  delete(){

    this.data = null;
    localStorage.removeItem(this.tabla);

    return this.data;
  }

}



// WEBPACK FOOTER //
// ./src/services/NotificacionesService.ts